import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormsErrorsService } from '../../services/forms-error.service';
import * as uuid from 'uuid';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss']
})
export class FormErrors implements OnInit,OnDestroy {

  private _form: AbstractControl;

  private formError;

  private dangerClass="border-danger";

  @Input()
  targetRef;

  @Input()
  skipHighlighter = false;

  @Input()
  set form (f){
    if(this.formError && !this.skipHighlighter){
      this.formsErrorService.unregisterFormError(this.formError);
    }
    this._form = f;
  };
  get form(){
    return this._form;
  }

  constructor(private el: ElementRef,private formsErrorService: FormsErrorsService,private renderer: Renderer2) { }

  ngOnInit() {
    if(this._form && !this.skipHighlighter){
      this.setFormError();
      this._form.statusChanges.subscribe(status => {
        if(status === 'VALID'){
          //removeFromErrorList;
          this.formsErrorService.unregisterFormError(this.formError);
          //removeClass
          this.cleanBorder();
        }else{
          //addToErrorList
          this.formsErrorService.registerFormError(this.formError);
        }
      })
      this.form.updateValueAndValidity();
    }
  }

  ngOnDestroy(){
    if(!this.skipHighlighter){
      this.formsErrorService.unregisterFormError(this.formError);
    }
  }

  setFormError(){
    this.formError = {
      form: this.form,
      elementRef: this.targetRef ? this.targetRef : this.el,
      uuid: uuid.v4()
    }
  }

  cleanBorder(){
    const itemToScrollTo = _.get(this.formError, `elementRef.nativeElement`) ? 
    _.get(this.formError, `elementRef.nativeElement`) : _.get(this.formError, `elementRef`);
    
    if (itemToScrollTo) {
      setTimeout(() => {
        this.renderer.removeClass(itemToScrollTo, this.dangerClass)
      },0)
    }
  }

}
